import { render, staticRenderFns } from "./CommonRacePointsCardParts.vue?vue&type=template&id=b4ac6aea&scoped=true"
import script from "./CommonRacePointsCardParts.vue?vue&type=script&lang=ts"
export * from "./CommonRacePointsCardParts.vue?vue&type=script&lang=ts"
import style0 from "./CommonRacePointsCardParts.vue?vue&type=style&index=0&id=b4ac6aea&prod&lang=scss&scoped=true"
import style1 from "./CommonRacePointsCardParts.vue?vue&type=style&index=1&id=b4ac6aea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ac6aea",
  null
  
)

export default component.exports